import { SampleDetailsLink } from "../../../../components";
import { enums } from "../../../../shim/jsbridge";
import { isBlankOrHangulFiller } from "../../../../utils";

const {
  state: { ERROR }
} = enums || {};

type Props = {
  fileName: string;
  sha1: string;
  classification: string;
  auxiliarySourceId: string;
  sampleId?: number | null;
  processingStatus?: number | null;
};

const ExtractedFilesAuxiliaryNameCell = ({
  fileName,
  sha1,
  classification,
  auxiliarySourceId,
  sampleId,
  processingStatus
}: Props) => {
  const displayName =
    !fileName || isBlankOrHangulFiller(fileName) ? sha1 : fileName;

  const sampleRecord = {
    sha1,
    threat_status: classification,
    classification,
    filename: sha1,
    auxiliary_source_id: auxiliarySourceId
  };

  return (
    <div className="flex flex-column">
      {sampleId && processingStatus !== ERROR ? (
        <SampleDetailsLink sampleRecord={sampleRecord} showTitle>
          {sha1}
        </SampleDetailsLink>
      ) : (
        <span className="overflow-ellipsis" title={sha1}>
          {sha1}
        </span>
      )}
      <span
        className="sample-link no-expand overflow-ellipsis w-100"
        style={{ minWidth: "40px", fontSize: "12px", marginTop: "3px" }}
      >
        {displayName}
      </span>
    </div>
  );
};

export default ExtractedFilesAuxiliaryNameCell;
